"use strict";

import $ from "jquery";

$(".js__removeOnClick").on("click", function () {
    $(this).remove();
});
